<template>
  <Section>
    <template #header>
      <div class="mr-auto font-weight-bold">
        Review: 
        <span class="red--text" v-if="pending">Pending</span>
        <span class="red--text" v-else-if="refunded">Complete - Refunded</span>
        <span class="red--text" v-else>Complete</span>
      </div>
    </template> 
    
    <div v-if="pending"><em>This dispute is under review.  Please allow for up to a week for our customer service team to review this concern.</em></div>
    <div v-else style="white-space: pre-wrap;">{{ lead.dispute.resolution_notes }}</div>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'

export default {
  name: 'LeadReviewSection',

  components: { Section },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  computed: {
    pending() {
      return this.lead.system_status == 'disputed'
    },

    refunded() {
      return this.lead.system_status == 'refunded'
    }
  },
}
</script>